module.exports = __webpack_public_path__ + "static/media/Archeops_gaussian2.3e4b7bad.png";